import axios from '@/axios-service';
import { ResponseContent, responseContent, Page, paginatedResponseContent } from '../types';
import { Owner, OwnerFilter, OwnerAdmittedCount } from './types';
import { buildParams } from '../index';
import { classToPlain } from 'class-transformer';

const MS_URL = 'senana/api/owners';
const responseAsOwner = responseContent(Owner)
const admittedCount = responseContent(OwnerAdmittedCount)


export const create = async (owner: Owner): Promise<ResponseContent<Owner>> => axios
  .post(MS_URL, classToPlain(owner))
  .then(responseAsOwner)

export const update = async (owner: Owner): Promise<ResponseContent<Owner>> => axios
  .put(`${MS_URL}/${owner.uuid}`, classToPlain(owner))
  .then(responseAsOwner)

export const getAll = async (filters: OwnerFilter, page: Page) => axios
  .get(MS_URL, buildParams(filters, page))
  .then(it => paginatedResponseContent(it.data, Owner));

export const getByUuid = async (uuid: string): Promise<ResponseContent<Owner>> => axios
  .get(`${MS_URL}/${uuid}`)
  .then(responseAsOwner)

export const getByOwnerKey = async (ownerKey: string): Promise<ResponseContent<Owner>> => axios
.get(`${MS_URL}/owner-key/${ownerKey}`)
.then(responseAsOwner)

export const deleteByUuid = async (uuid: string) => axios
  .delete(`${MS_URL}/${uuid}`)

export const setAdmitted = async (owner: Owner): Promise<ResponseContent<Owner>> => axios
  .patch(`${MS_URL}/${owner.uuid}`, classToPlain(owner))
  .then(responseAsOwner)

export const getAdmittedCount = async (onlyUserOwners: boolean = false): Promise<ResponseContent<OwnerAdmittedCount>> => axios
  .get(`${MS_URL}/admitted`, { params: { onlyUserOwners } },)
  .then(admittedCount)
